/* istanbul ignore file */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { v4 as uuidv4 } from 'uuid';
import { env } from '../lib/env.ts';

const correlationId = uuidv4();

let reactPlugin = null;
let appInsights = null;

const createTelemetryService = () => {
  const initialize = (instrumentationKey, browserHistory, enhanceEnvelope) => {
    let aiInstrumentationKey;
    let disableTelemetry;

    const envInstrumentationKey = env.aiInstrumentationKey;
    if (envInstrumentationKey) {
      aiInstrumentationKey = envInstrumentationKey;
      disableTelemetry = true;
    } else {
      aiInstrumentationKey = instrumentationKey;
      disableTelemetry = false;
    }

    if (!instrumentationKey) {
      throw new Error('Instrumentation key not provided');
    }

    if (!browserHistory) {
      throw new Error('Could not initialize Telemetry Service');
    }

    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: aiInstrumentationKey,
        disableTelemetry,
        loggingLevelTelemetry: 1,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });

    appInsights.loadAppInsights();

    appInsights.addTelemetryInitializer((envelope) => {
      if (envelope.baseData.target && envelope.baseData.target.indexOf('mouseflow.com') > -1) {
        return false;
      }

      // eslint-disable-next-line no-param-reassign
      envelope.tags['ai.cloud.role'] = 'Registration-UI';
      // eslint-disable-next-line no-param-reassign
      envelope.data.CorrelationId = correlationId;

      if (enhanceEnvelope) {
        enhanceEnvelope(envelope);
      }

      return true;
    });
  };

  return {
    reactPlugin,
    appInsights,
    initialize,
  };
};

export const ai = createTelemetryService();

export const getAppInsights = () => appInsights;

export const getCorrelationId = () => correlationId;
